module.exports = __webpack_public_path__ + "static/media/me.54b38d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me.jpg
// module id = 78
// module chunks = 0